import React, { useCallback, useContext } from 'react';
import RcSlider from 'rc-slider';
import analytics from '@nerdwallet/analytics';
import {
  useAnalyticsPageView,
  useSegmentAnalytics,
} from '@nerdwallet/seo-analytics';
import {
  SegmentImpressionContext,
  useSegmentImpressionHook,
} from '../../../lib/analytics/segment-impression';
import useTimer from '../../../lib/analytics/use-timer';

const DTI_MIN = 20;
const DTI_MAX = 50;

const CALCULATOR_NAME = 'how_much_house_can_i_afford_calculator';

const Slider: React.FC<{
  dti: number;
  handleChange: (value: number) => void;
  onDragStart: () => void;
  onDragEnd: () => void;
}> = ({ dti, handleChange, onDragStart, onDragEnd }) => {
  const segment = useSegmentAnalytics()?.analytics;
  const { eventId: formViewedId } = useContext(SegmentImpressionContext);
  const { pageViewId } = useAnalyticsPageView();
  const { eventId: featureViewedId, ref } = useSegmentImpressionHook({
    eventType: 'feature_viewed',
    attributes: {
      entity_name: 'form_result_graph',
      section_name: 'form',
      item_position: null,
      item_copy: CALCULATOR_NAME,
      content_id: null,
      parent_event_id: formViewedId,
    },
  });

  const trackGraphHovered = useCallback(
    (secondsHovered) => {
      segment?.track('feature_interacted', {
        event_id: analytics.uuid(),
        entity_name: 'form_result_graph',
        section_name: 'form',
        item_position: null,
        item_copy: CALCULATOR_NAME,
        interaction_type: 'hover',
        content_id: null,
        additional_attributes: [
          {
            'time (seconds) hovering on the results': secondsHovered / 1000,
          },
        ],
        parent_event_id: featureViewedId,
        pageview_id: pageViewId,
      });
    },
    [featureViewedId, pageViewId, segment]
  );
  const { startTimer, stopTimer } = useTimer(trackGraphHovered);

  return (
    <div onMouseEnter={startTimer} onMouseLeave={stopTimer} ref={ref}>
      <RcSlider
        defaultValue={dti}
        value={dti}
        min={DTI_MIN}
        max={DTI_MAX}
        onBeforeChange={onDragStart}
        onAfterChange={onDragEnd}
        onChange={handleChange}
      />
    </div>
  );
};

export default Slider;
